import React from "react";
import Commentbox from "./CommentBoxInput";
import Comment from "./Comment";

function CommentWrapper(props) {
  return (
    <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
    <div className="commen-wrapper">
      <div className="comment-wrapper-sec">
        <div className="comment-wrapper-content">
          <Commentbox />
          {props?.data?.map((item, index) => {
            return (
              <>
                <Comment
                  ProfileAvatar={item?.ProfileAvatar}
                  ProfileName={item?.ProfileName}
                  Upvotes={item?.Upvotes}
                  Time={item?.Time}
                  TwitterID={item?.TwitterID}
                  TwitterFollowers={item?.TwitterFollowers}
                  Comment={item?.Comment}
                />
                <div style={{ marginLeft: "10%" }}>
                  {item?.Reply?.map((v) => {
                    return (
                      <Comment
                        reply={true}
                        ProfileAvatar={v?.ProfileAvatar}
                        ProfileName={v?.ProfileName}
                        Upvotes={v?.Upvotes}
                        Time={v?.Time}
                        TwitterID={v?.TwitterID}
                        TwitterFollowers={v?.TwitterFollowers}
                        Comment={v?.Comment}
                      />
                    );
                  })}
                </div>
              </>
            );
          })}
        </div>
      </div>
    </div>
    </div>
  );
}
export default CommentWrapper;
